<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col
        lg="12"
        style="display:block; text-align:center;padding-bottom:15px;font-size:1.2em;"
        v-if="total > 0"
      >
        <span style="padding:5px;">Total Records:</span>
        <b style="border-right:1px solid white; padding-right:5px;">{{
          total
        }}</b>
        <span style="padding:5px;">Total Price:</span>
        <b
          >${{
            totalPrice.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
          }}</b
        >

        <b-button
          class="download-button"
          variant="primary"
          size="lg"
          @click="
            downloadExcel(
              $http,
              params,
              setLoading,
              excelDownload,
              'TableReport'
            )
          "
        >
          <LoadingCard
            style="display:inline-block;"
            v-if="loadingDownload"
          ></LoadingCard>
          <i
            v-show="!loadingDownload"
            class="fa fa-file-excel-o"
            aria-hidden="true"
          ></i>
          <span>Download</span>
        </b-button>
      </b-col>
      <b-col lg="12">
        <b-card>
          <div slot="header" v-html="title"></div>
          <b-table
            responsive="sm"
            :busy.sync="loading"
            id="my-table"
            :items="myProvider"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template v-slot:cell(status)="{ value }">
              <b-badge :variant="getBadge(value)">{{ value }}</b-badge>
            </template>
            <template v-slot:cell(fnsid)="data" >
              <a target="_blank"
                v-bind:href="
                  envVar +
                    'tracker_private/includes/customerReportPublic.php?ftrack=' +
                    data.value + '-' + data.item.fnsra
                "
                >{{ data.value }}</a
              >
            </template></b-table
          >
          <div style="display:flex;justify-content: center; ">
            <b-pagination
              v-if="paginated === 'true'"
              v-show="total > 0"
              :total-rows="rows"
              v-model="currentPage"
              :per-page="perPage"
              aria-controls="my-table"
              page-class="customPage"
            ></b-pagination>
            <b-form-select
              v-if="paginated === 'true'"
              v-show="total > 0"
              v-model="perPage"
              :options="options"
              class="select"
            ></b-form-select>
          </div>
        </b-card>
        <p v-if="message !== ''">{{ message }}</p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LoadingCard from "../../../components/shared/LoadingCard.vue";
import { downloadExcel, from, to } from "../../../utils/Utils";

export default {
  props: [
    "type",
    "date_from",
    "date_to",
    "paginated",
    "client_location",
    "prodGroup"
  ],
  name: "TableAllDataPaginated",
  data: () => {
    return {
      downloadExcel: downloadExcel,
      from: from,
      to: to,
      perPage: 10,
      currentPage: 1,
      envVar: process.env.VUE_APP_TRACKER_URL,
      excelDownload: "",
      loading: false,
      loadingDownload: false,
      total: 0,
      totalPrice: 0,
      title: "",
      params: {},
      endpoint: "",
      fields: [
        { key: "locat", label: "Location" },
        { key: "fnsid", label: "FNSID", sortable: true },
        { key: "fnsra", label: "RANUM" },
        { key: "invno", label: "Invoice #" },
        {
          key: "pMake",
          label: "Manufacturer",
          sortable: true,
          style: "width: 250px"
        },
        { key: "pMode", label: "Model" },
        { key: "sernm", label: "Serial Number" },
        { key: "recvD", label: "Received" },
        { key: "shipd", label: "Shipped" },
        { key: "price", label: "Price", sortable: true }
      ],
      options: [
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 50, text: "50" },
        { value: 100, text: "100" }
      ],
      message: ""
    };
  },
  computed: {
    rows() {
      return this.total;
    }
  },
  methods: {
    setLoading(loading) {
      this.loadingDownload = loading;
    },
    async myProvider(ctx) {
      if (this.paginated) {
        this.params["limit"] = ctx.perPage;
        this.params["offset"] = ctx.currentPage -1;
      }
      if (this.date_from || this.date_to) {
        this.params["date_from"] = this.date_from;
        this.params["date_to"] = this.date_to;
      }
      if (this.client_location !== "") {
        this.params["client_location"] = this.client_location;
      }
      if (this.prodGroup !== "") {
        this.params["prodGroup"] = this.prodGroup;
      }

      this.loading = true;
      try {
        const response = await this.$http.get(this.endpoint, {
          params: this.params
        });
        if (response.data && response.data.records) {
          this.loading = false;
          this.total = response.data.count;
          response.data.records.forEach(obj => {
            if (obj.price != undefined) {
              this.totalPrice =
                this.totalPrice + parseFloat(obj.price.replace("$", ""));
            }
          });
          return response.data.records;
        } else {
          this.message = response.data.message;
          this.loading = false;
          this.params = {};
        }
      } catch (error) {
        this.total = 0;
        this.loading = false;
        this.params = {};
        return [];
      }
    }
  },
  mounted() {
    this.title = this.type.toLocaleUpperCase();
    if (this.type === "Shipped") {
      this.endpoint = "api/tables/shipped.php";
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL +
        "api/tables/downloadEntireDeliveredEquipment.php";
    } else if (this.type === "backlog") {
      this.endpoint = "api/tables/back.php";
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL +
        "api/tables/downloadEntireActiveBacklog.php";
    } else if (this.type === "war") {
      this.title = "Under warranty";
      this.endpoint = "api/tables/war.php";
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL + "api/tables/war.php";
    } else if (this.type === "OEMShip") {
      this.title = "OEM Shipped";
      this.endpoint = "api/tables/oem_delivered.php";
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL + "api/tables/oem_delivered.php";
    } else if (this.type === "OEM") {
      this.title = "OEM";
      this.endpoint = "api/tables/oem_backlog.php";
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL + "api/tables/oem_backlog.php";
    }
  },
  components: { LoadingCard }
};
</script>
<style>
.complaintClass {
  width: 200px;
}
.download-button {
  margin: auto;
  float: right;
  font-weight: 500;
  padding: 0.7em;
  font-size: 0.9em;
  border-radius: 0.3rem;
  color: white;
  background: #20a8d8;
}
.sk-double-bounce {
  height: 20px !important;
  width: 20px !important;
  line-height: 55px;
  margin: auto;
}
.download-button:hover {
  text-decoration: none !important;
  color: white;
}
.fa-file-excel-o {
  font-size: 1em;
  color: #ffffff68;
  transform: rotate(30deg);
  padding-right: 0.5em;
}
.select {
  width: 100px;
  margin-left: 20px;
}
</style>
